import { MappedWifiEvents, WifiDashboardsAPIResponse, WifiState } from "./types"

/* Breakpoints -> hours range -> seconds range
0 -> 0:00h - 0:59h -> 0 - 3599
1 -> 1:00h - 1:59h -> 3600 - 7199
2 -> 2:00h - 2:59h -> 7200 - 10799
3 -> 3:00h - 3:59h -> 10800 - 14399
4 -> 4:00h - 4:59h -> 14400 - 17999
5 -> 5:00h - 5:59h -> 18000 - 21599
6 -> 6:00h - 6:59h -> 21600 - 25199
7 -> 7:00h - 7:59h -> 25200 - 28799
8 -> 8:00h - 8:59h -> 28800 - 32399
9 -> 9:00h - 9:59h -> 32400 - 35999
10 -> 10:00h - 10:59h -> 36000 - 39599
11 -> 11:00h - 11:59h -> 39600 - 43199
12 -> 12:00h - 12:59h -> 43200 - 46799
13 -> 13:00h - 13:59h -> 46800 - 50399
14 -> 14:00h - 14:59h -> 50400 - 53999
15 -> 15:00h - 15:59h -> 54000 - 57599
16 -> 16:00h - 16:59h -> 57600 - 61199
17 -> 17:00h - 17:59h -> 61200 - 64799
18 -> 18:00h - 18:59h -> 64800 - 68399
19 -> 19:00h - 19:59h -> 68400 - 71999
20 -> 20:00h - 20:59h -> 72000 - 75599
21 -> 21:00h - 21:59h -> 75600 - 79199
22 -> 22:00h - 22:59h -> 79200 - 82799
23 -> 23:00h - 23:59h -> 82800 - 86399
24 -> 24:00h - 24:59h -> 86400 - 89999
*/

const plots = [
  { min: 0, max: 3599000, label: '0', },
  { min: 3600000, max: 7199000, label: '- 1h', },
  { min: 7200000, max: 10799000, label: '- 2h', },
  { min: 10800000, max: 14399000, label: '- 3h', },
  { min: 14400000, max: 17999000, label: '- 4h', },
  { min: 18000000, max: 21599000, label: '- 5h', },
  { min: 21600000, max: 25199000, label: '- 6h', },
  { min: 25200000, max: 28799000, label: '- 7h', },
  { min: 28800000, max: 32399000, label: '- 8h', },
  { min: 32400000, max: 35999000, label: '- 9h', },
  { min: 36000000, max: 39599000, label: '- 10h', },
  { min: 39600000, max: 43199000, label: '- 11h', },
  { min: 43200000, max: 46799000, label: '- 12h', },
  { min: 46800000, max: 50399000, label: '- 13h', },
  { min: 50400000, max: 53999000, label: '- 14h', },
  { min: 54000000, max: 57599000, label: '- 15h', },
  { min: 57600000, max: 61199000, label: '- 16h', },
  { min: 61200000, max: 64799000, label: '- 17h', },
  { min: 64800000, max: 68399000, label: '- 18h', },
  { min: 68400000, max: 71999000, label: '- 19h', },
  { min: 72000000, max: 75599000, label: '- 20h', },
  { min: 75600000, max: 79199000, label: '- 21h', },
  { min: 79200000, max: 82799000, label: '- 22h', },
  { min: 82800000, max: 86399000, label: '- 23h', },
  { min: 86400000, max: 89999000, label: '- 24h', },
]

export default function(events: WifiDashboardsAPIResponse): WifiState {
  const sortedEvents: MappedWifiEvents = {}
  const now = new Date().getTime()
  let latestSignal: null | number = null

  plots.forEach(plot => {
    const { min, max, label } = plot

    const event = events.wifiEvent.find(event => {
      const eventDate = new Date(event.eventTs).getTime()
      const interval = now - eventDate
      return interval >= min && interval < max
    })

    const setEvent = event ?
    {
      channelNumber: Number(event.channelNumber.filter(entry => !!Number(entry))[event.channelNumber.length - 1]) || 0,
      signal: Number(event.signal.filter(entry => !!Number(entry))[event.signal.length - 1]) || 0,
      frequency: Number(event.frequency.filter(entry => !!Number(entry))[event.frequency.length - 1]) || 0,
      eventTs: event.eventTs,
    }
    : undefined

    if (!latestSignal && setEvent?.signal) {
      latestSignal = setEvent.signal
    }

    sortedEvents[label] = setEvent
  })

  return {
    events: sortedEvents,
    minSignal: events?.customWfSigMin ? Number(events.customWfSigMin) : null,
    maxSignal: events?.customWfSigMax ? Number(events.customWfSigMax) : null,
    latestSignal,
    score: events?.wifiScore ? Number(parseFloat(events.wifiScore).toFixed(1)) : null,
  }
}
